import { Expose, Type } from 'class-transformer'
import { BookmarkPenNameType } from './BookmarkPenNameType'

export class BookmarkBookType {
  @Expose() id: number

  @Expose() title: string

  @Expose() coverResizeImgPath: string

  @Expose() coverImgPath: string

  @Expose()
  @Type(() => BookmarkPenNameType)
  penName: BookmarkPenNameType
}
